export default new class AnimationManager {
  animations = new Map()

  init = () => {
    window.addEventListener('scroll', this.update)
  }

  onEnterView = (element, callback, replay = false) => {
    this.animations.set(element, { element, callback, played: false, replay })
  }

  getObjectInView = element => {
    const bounds = element.getBoundingClientRect()
    const top = (window.innerHeight / 2 - bounds.top) / window.innerHeight
    const bottom = (bounds.bottom - window.innerHeight / 2) / window.innerHeight
    // -0.5 is right when it enters view
    // 0 is halfway mark
    return top >= -0.25 && bottom >= -0.25
  }

  update = () => {
    ;[...this.animations.values()].forEach(animation => {
      if (this.getObjectInView(animation.element)) {
        if (!animation.played) {
          animation.callback()
          animation.played = true
        }
      } else {
        if (animation.replay) {
          animation.played = false
        }
      }
    })
  }
}()
